export default __webpack_public_path__ + "assets/ico_contract_draft-8b976efb.svg";